import React from "react";
import { AiOutlineReload } from "react-icons/ai";

export const OutlineButton = ({
  onClick,
  buttonName,
  icon,
  color,
  type,
  padding,
}) => {
  return (
    <button
      
      className={`flex justify-center border border-primary  items-center md:${
        padding ? `px-${padding}` : "px-6"
      } lg:${
        padding ? `px-${padding}` : "px-6"
      }   px-4 py-2 rounded-full  text-primary focus:outline-none whitespace-nowrap`}
      type={type ?? "button"}
      onClick={onClick}>
      <div className="md:text-xl lg:text-xl text-lg">{icon}</div>
      <span
        className={`md:${icon ? "ml-2" : "ml-0"} lg:${icon ? "ml-2" : "ml-0"} ${
          icon ? "ml-1" : "ml-0"
        } md:text-base lg:text-base text-sm`}>
        {buttonName}
      </span>
    </button>
  );
};

export const OutLinedHoverButton = ({ onClick, buttonName, onDoubleClick }) => {
  return (
    <button
      className="flex items-center md:px-6 lg:px-6  md:py-2 lg:py-2 px-4 py-2 border border-primary text-primary rounded-lg hover:bg-primary hover:text-white focus:outline-none"
      onClick={onClick}
      onDoubleClick={onDoubleClick}>
      <span>{buttonName}</span>
    </button>
  );
};
